import React, { useEffect, useState } from "react";

interface TextBoxProps {
  type?: string;
  // id?:string;
  className?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onEnter13?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  icon13css?: string;
  icon13small?: boolean;
  placeholder?: string;
  style?: React.CSSProperties;
  readOnly?: boolean;
  maxLength?: number | undefined;
}

const TextBox: React.FC<TextBoxProps> = ({
  type = "text",
  className = "form-control",
  value = "",
  onChange = () => { },
  onEnter13 = () => { },
  placeholder = "",
  style = {},
  icon13css = null,
  icon13small = false,
  readOnly = false,
  maxLength = undefined,
  // id
}) => {
  // Handle key down to detect "Enter" key
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter" && onEnter13) {
      onEnter13(e); // Call the custom onEnter13 event handler
    }
  };

  const handleClick13 = () => {
    if (onEnter13) {
      const e = new KeyboardEvent("keydown", { key: "Enter" });
      // Create a fake input element
      const inputElement = document.createElement("input");

      // Convert native event to a React synthetic event using Object.assign
      const reactEvent = Object.assign({}, e, {
        currentTarget: inputElement,
        target: inputElement,
        nativeEvent: e,
        preventDefault: () => e.preventDefault(),
        stopPropagation: () => e.stopPropagation(),
      }) as unknown as React.KeyboardEvent<HTMLInputElement>;

      onEnter13(reactEvent);
    }
  };

  const [valueMine, setValueMine] = useState<any>(value);
  useEffect(() => {
    setValueMine(value);
  }, [value])

  const handleClear = () => {
    setValueMine("");
    const simulatedEvent = {
      target: { value: "" },
    } as React.ChangeEvent<HTMLInputElement>;
    onChange(simulatedEvent);
  };


  const fontSize = icon13small ? "1.2em" : "1.5em";
  return (
    <div style={{ position: "relative", width: "100%" }}>
      <input
        // {...(id ? { id } : {})} // Add id only if it has a value
        type={type}
        className={className}
        value={valueMine}
        onChange={(e) => {
          onChange(e);
          setValueMine(e.target.value)
        }}
        onKeyDown={handleKeyDown} // Attach the keydown event handler
        placeholder={placeholder}
        style={style}
        readOnly={readOnly}
        maxLength={maxLength}
      />
      {(valueMine && !readOnly) && (
        <i
          onClick={handleClear}
          style={{
            position: "absolute",
            right: icon13css ? "28px" : "2px",
            top: "54%",
            transform: "translateY(-50%)",
            cursor: "pointer",
            color: "#888",
            fontSize: fontSize
          }}
          className="bx bx-x"
        ></i>
      )}

      {icon13css && (
        <i
          onClick={handleClick13}
          style={{
            position: "absolute",
            right: "2px",
            top: "54%",
            transform: "translateY(-50%)",
            cursor: "pointer",
            color: "#888",
            fontSize: fontSize
          }}
          className={icon13css}
        ></i>
      )}

    </div>
  );
};

export default TextBox;
